module.exports = __webpack_public_path__ + "img/exit-ico.b80a2dd4.svg";